import { cn as e } from "../cn.js";
import { getStyles as t } from "./styles.js";
import * as n from "react";
import { Accordion as r } from "@ark-ui/react/accordion";
import { ChevronDownIcon as i } from "lucide-react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
// src/design/accordion/index.tsx
var s = n.forwardRef(({ items: n = [], showIndicator: s = !0, config: c, className: l, ...u }, d) => {
	let f = t(c);
	return /* @__PURE__ */ a(r.Root, {
		ref: d,
		className: e(f.root(), l),
		orientation: c?.orientation,
		collapsible: !0,
		...u,
		children: n.map((t) => /* @__PURE__ */ o(r.Item, {
			value: t.value,
			disabled: t.disabled,
			className: e(f.item(), t.itemClassName),
			children: [/* @__PURE__ */ o(r.ItemTrigger, {
				className: e(f.itemTrigger(), t.triggerClassName),
				children: [t.trigger, s && /* @__PURE__ */ a(r.ItemIndicator, {
					className: e(f.itemIndicator(), t.indicatorClassName),
					children: /* @__PURE__ */ a(i, {})
				})]
			}), /* @__PURE__ */ a(r.ItemContent, {
				className: e(f.itemContent(), t.contentClassName),
				children: /* @__PURE__ */ a("div", {
					className: f.itemBody(),
					children: t.content
				})
			})]
		}, t.value))
	});
});
s.displayName = "Accordion";
var c = n.forwardRef(({ children: n, className: i, config: o, orientation: s, ...c }, l) => {
	let u = {
		...o,
		orientation: s ?? o?.orientation
	}, d = t(u);
	return /* @__PURE__ */ a(r.Root, {
		ref: l,
		className: e(d.root(), i),
		orientation: u.orientation,
		...c,
		children: n
	});
});
c.displayName = "Accordion.Root";
var l = n.forwardRef(({ children: n, className: i, config: o, ...s }, c) => {
	let l = t(o);
	return /* @__PURE__ */ a(r.Item, {
		ref: c,
		className: e(l.item(), i),
		...s,
		children: n
	});
});
l.displayName = "Accordion.Item";
var u = n.forwardRef(({ children: n, className: i, config: o, ...s }, c) => {
	let l = t(o);
	return /* @__PURE__ */ a(r.ItemTrigger, {
		ref: c,
		className: e(l.itemTrigger(), i),
		...s,
		children: n
	});
});
u.displayName = "Accordion.ItemTrigger";
var d = n.forwardRef(({ children: n, className: o, config: s, ...c }, l) => {
	let u = t(s);
	return /* @__PURE__ */ a(r.ItemIndicator, {
		ref: l,
		className: e(u.itemIndicator(), o),
		...c,
		children: n ?? /* @__PURE__ */ a(i, {})
	});
});
d.displayName = "Accordion.ItemIndicator";
var f = n.forwardRef(({ children: n, className: i, config: o, ...s }, c) => {
	let l = t(o);
	return /* @__PURE__ */ a(r.ItemContent, {
		ref: c,
		className: e(l.itemContent(), i),
		...s,
		children: n
	});
});
f.displayName = "Accordion.ItemContent";
var p = n.forwardRef(({ children: n, className: r, config: i, ...o }, s) => {
	let c = t(i);
	return /* @__PURE__ */ a("div", {
		ref: s,
		className: e(c.itemBody(), r),
		...o,
		children: n
	});
});
p.displayName = "Accordion.ItemBody";
var m = r.Context, h = Object.assign(s, {
	Root: c,
	Item: l,
	ItemTrigger: u,
	ItemIndicator: d,
	ItemContent: f,
	ItemBody: p,
	Context: m,
	getStyles: t
});
export { h as Accordion };

//# sourceMappingURL=index.js.map